import React from "react";
import ReactDOM from "react-dom/client";
import "98.css";

import App from "./components/App";
import LayoutStudio from "./components/LayoutStudio";
import "./global-styles.css";
import { initKioskFromUrl } from "./kiosk";

// `?layout` boots the Layout Studio INSTEAD of the site: no websocket,
// no game consumed, no login/boot choreography — a layout arrangement
// bench, not a player surface. Dev builds only: a shared ?layout link
// in prod must show the piece, not the workbench.
const layoutMode =
  process.env.NODE_ENV !== "production" &&
  new URLSearchParams(window.location.search).has("layout");

// Nothing in the piece uses native HTML drag-and-drop (cards, windows
// and icons all drag via pointer events), so no OS drag session may ever
// start: on Linux Firefox a drag of selected text (stats.txt) dropped on
// a non-accepting page can leave the browser stuck mid-drag — pointer
// moves, every click ignored, no recovery without a keyboard (Bugzilla
// 736811 and friends). Capture phase so nothing can opt back in.
document.addEventListener("dragstart", (e) => e.preventDefault(), true);

// `?kiosk` / `?kiosk=off`: sticky per-machine flag, see kiosk.js.
initKioskFromUrl();

// Everything on screen is the pixel font; painting even one frame in a
// fallback font looks broken in a way this piece can't afford. Block the
// first render until both weights are in (they're self-hosted woff2s, a
// few KB), with a timeout so a busted font never blanks the site.
const fontsReady = Promise.race([
  Promise.all([
    document.fonts.load('11px "Pixelated MS Sans Serif"'),
    document.fonts.load('bold 11px "Pixelated MS Sans Serif"'),
  ]),
  new Promise((resolve) => setTimeout(resolve, 2500)),
]);

fontsReady.then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(layoutMode ? <LayoutStudio /> : <App />);
});
